import type { DataNode } from 'antd/es/tree';
import type {
  UseMutateAsyncFunction,
  RefetchOptions,
  RefetchQueryFilters,
  QueryObserverResult,
} from 'react-query';
import type { ProjectId } from 'api/models';
import type {
  RearrangeFilesPayload,
  RearrangeFoldersPayload,
} from 'api/project-files';
import type { ProjectFileGroup } from 'api/project-files/types';

const errorMessages = [
  'title',
  'errorLoneFiles',
  'errorNestedFolders',
] as const;

export type ErrorMessages = {
  [Key in typeof errorMessages[number]]: string;
};

const toastMessages = [
  'successTitle',
  'successMessage',
  'errorTitle',
  'errorMessage',
];

type ToastMessages = {
  [Key in typeof toastMessages[number]]: string;
};

export type DeltaPayload =
  | {
      // Folder was rearranged
      folderKey: string | number;
      newPosition: number;
    }
  | {
      // File was rearranged, across folders
      fileKey: string | number;
      newPosition: number;
      newFolderKey: string | number;
    }
  | {
      // File was rearranged, within its folder
      fileKey: string | number;
      newPosition: number;
    }
  | null;

export type RearrangeFiles = UseMutateAsyncFunction<
  void,
  unknown,
  RearrangeFilesPayload,
  unknown
>;

export type RearrangeFolders = UseMutateAsyncFunction<
  void,
  unknown,
  RearrangeFoldersPayload,
  unknown
>;

export const PRIVATE = 'private';

export interface RearrangeTreeProps {
  folders: DataNode[];
  setFolders: React.Dispatch<React.SetStateAction<DataNode[]>>;
  projectId: ProjectId;
}

export interface RearrangeModalProps {
  onClose: VoidFunction;
  folders?: ProjectFileGroup[];
  projectId: ProjectId;
  canUploadPrivateFiles?: boolean;
  canUploadSharedFiles?: boolean;
}

export interface HandleDropParams {
  info;
  folders: DataNode[];
  setFolders: React.Dispatch<React.SetStateAction<DataNode[]>>;
  rearrangeFiles: RearrangeFiles;
  rearrangeFolders: RearrangeFolders;
  refetchFolders: <TPageData>(
    options?: (RefetchOptions & RefetchQueryFilters<TPageData>) | undefined,
  ) => Promise<QueryObserverResult<ProjectFileGroup[], unknown>>;
  errorMessages: ErrorMessages;
  toastMessages: ToastMessages;
}
